import type {ValueEditorLocalizations} from './types';

export class ValueEditorLocalizationManager<LOC extends ValueEditorLocalizations> {
    private localizations: LOC;

    constructor(defaultLocalizations: Required<Readonly<LOC>>) {
        this.localizations = {...defaultLocalizations};
    }

    public setLocalization<KEY extends keyof LOC>(code: KEY, message: LOC[KEY]) {
        this.localizations[code] = message;
    }

    public setAll(localizations: LOC) {
        this.localizations = {...this.localizations, ...localizations};
    }

    public getLocalization<KEY extends keyof LOC>(code: KEY): LOC[KEY] | KEY {
        return this.localizations[code] ?? code;
    }

    public getAll(): LOC {
        return {...this.localizations};
    }
}